import React from 'react';
import { useState } from 'react';
import { Redirect } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import Sidebar from '../sidebar/Sidebar';
import ClassPage from './ClassPage';

const OnlineClass = ({ loggedIn, handleLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  if (!loggedIn) {
    return <Redirect to='/' />;
  }
  const openSidebar = () => {
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className='container'>
      <Navbar sidebarOpen={sidebarOpen} openSidebar={openSidebar} />
      <ClassPage />
      <Sidebar
        sidebarOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        handleLogout={handleLogout}
      />
    </div>
  );
};

export default OnlineClass;
